import React, { Component, Fragment } from "react";
import { Row, Card,CardHeader, CardTitle, Button, CardBody, FormGroup, Input, Badge,DropdownMenu, DropdownItem, CustomInput } from "reactstrap";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import classnames from "classnames";
import { NavLink } from "react-router-dom";
import DataTablePagination from "../../../components/DatatablePagination";
import ItemDropdown from "../../../components/customer/ItemDropdown";
import ReactTable from "react-table";
import swal from 'sweetalert';
import { getCustomerWord, zeroPad } from "../../../helpers/Utils";

import AddEnquiryModal from "../../../containers/enquiries/AddEnquiryModal";
import EditEnquiryModal from "../../../containers/enquiries/EditEnquiryModal";
import ViewModal from "../../../containers/enquiries/ViewModal";
import CompleteModal from "../../../containers/enquiries/CompleteModal";

import {REST_API_END_POINT,dataEncryptKey,JQUERY_MODULE, ENQUIRY_STATUS, REST_API_BASE_URL} from "../../../constants/defaultValues";

import axios from 'axios';
import SimpleCrypto from "simple-crypto-js";
import moment from "moment";
import JsFileDownloader from 'js-file-downloader';

const dataCrypto = new SimpleCrypto(dataEncryptKey);
const customerWord = getCustomerWord();

export default class AllEnquiries extends Component {
	
	constructor(props) {
		super(props);
		
		this.state = {
			enquiries:[],
			search: '',
			enquiry_id:0,
			modalOpenAdd:false,
			modalOpenEdit:false,
			modalOpenView:false,
			modalOpenInvoice:false,
			modalOpenInProgress:false,
			modalOpenComplete:false,
			selectAll:0,
			selectedIds:[],
			user_privileges:[],
		};
		
		this.toggleModalAdd = this.toggleModalAdd.bind(this);
		this.toggleModalView = this.toggleModalView.bind(this);
		this.toggleModalInProgress = this.toggleModalInProgress.bind(this);
		this.toggleModalEximate = this.toggleModalEximate.bind(this);
		this.toggleModalComplete=this.toggleModalComplete.bind(this);
		this.dataListRender = this.dataListRender.bind(this);
		this.toggleSelectAll = this.toggleSelectAll.bind(this);
		this.cancelOrders = this.cancelOrders.bind(this);
		this.activeItem = this.activeItem.bind(this);
	}
	
	componentDidMount(){
		this.dataListRender();
		var user_id=localStorage.getItem('user_id');
		var formData = new FormData();
		formData.append('user_id',user_id);
		
		axios.post(REST_API_END_POINT+'/dashboard/get-user-privileges',formData).then((res)=>{
			if(res.data.status==1){
				var user_privileges = res.data.user_privileges;
				this.setState({
					user_privileges
				});
			}
		}).catch(e => { 
			console.log("Addition failed , Error ", e); 
		});
	}
	
	dataListRender() {
		var facility_id = localStorage.getItem('facility_id');
		facility_id =  dataCrypto.decrypt(facility_id);
        var formData = new FormData();
        formData.append('facility_id',facility_id);
		
		axios.post(REST_API_END_POINT+'enquiries/all-enquiries',formData).then((res)=>{
			var data = res.data;
			
			if(data.enquiries){
				var enquiries=data.enquiries;
				enquiries = enquiries.map(row=>{
					
					const order_status = ENQUIRY_STATUS.find(r=>{ return r.value==row.status });
					if(order_status!=null){
						row.status_text = order_status.label;
						row.status_badge = <Badge color={order_status.badge} style={{ whiteSpace: 'break-spaces' }} >{order_status.label}</Badge>;
					}else{
						row.status_text ="";
						row.status_badge ="";
					}
					
					return row;
				})
				this.setState({
			        enquiries: enquiries,
				});
			}else{
				this.setState({
					enquiries: [],
				});
			}
        }).catch(e =>{
			console.log("Addition failed , Error ", e);
		});
	}
	
	toggleModalAdd = () => {
		this.setState({
			modalOpenAdd: !this.state.modalOpenAdd
		});
	};
	
	toggleModalEdit = (e,enquiry_id =0) => {
		this.setState({
		  enquiry_id: parseInt(enquiry_id),
		  modalOpenEdit: !this.state.modalOpenEdit
		});
	};
	
	toggleModalView = (e,enquiry_id =0) => {
		this.setState({
		  enquiry_id: parseInt(enquiry_id),
		  modalOpenView: !this.state.modalOpenView
		});
	};
	
	toggleModalInProgress = (e,enquiry_id =0) => {
		this.setState({
		  enquiry_id: parseInt(enquiry_id),
		  modalOpenInProgress: !this.state.modalOpenInProgress
		});
	};
	
	toggleModalComplete = (e,enquiry_id =0) => {

		this.setState({
		  enquiry_id: parseInt(enquiry_id),
		  modalOpenComplete: !this.state.modalOpenComplete
		});
		
	};
		
	toggleModalCompleteData = (e,enquiry_id =0) => {

		this.setState({
		  enquiry_id: parseInt(enquiry_id),
		  modalOpenComplete: !this.state.modalOpenComplete
		});
		this.dataListRender();
		
	};
	toggleModalEximate = (e,enquiry_id)=>{
		var facility_id = localStorage.getItem('facility_id');
		facility_id =  dataCrypto.decrypt(facility_id);
		var user_id = localStorage.getItem('user_id');
		var formData = new FormData();
		//formData.append('enquiry_ids',JSON.stringify(selectedIds));
		formData.append('user_id',user_id);
		formData.append('facility_id',facility_id);
		formData.append('enquiry_id',enquiry_id);

		// window.location="/app/enquiries/all-enquiries/convert-to-estimate/"+enquiry_id;	
		
		axios.post(REST_API_END_POINT+'enquiries/convert_to_estimate',formData).then((res)=>{
			var data = res.data;
		
			 document.getElementById("delete-enquiries").disabled=false;
			//  if(data.status==8){
			// 	swal("Expired","Expired","warning");
			// }		
			
						
			if(data.status==7){
				
				swal("Success","Converted to Estimate & Quotation","success");
				this.dataListRender();
			}else{
				this.dataListRender();
				swal("Failed","failed","warning");
			}
			 
		}).catch(e =>{
			console.log("Addition failed , Error ", e);
			// document.getElementById("delete-enquiries").disabled=false;
		});
		
	}
	activeItem=(e,enquiry_id)=>{		
	    let selectedIds = this.state.selectedIds;		
	    let selectAll = this.state.selectAll;		
		if(e.target.checked){
			selectedIds.push(enquiry_id);
			
		}else{
		  var x=selectedIds.indexOf(enquiry_id);
		  if(x>=0){
				selectedIds.splice(x,1);
		  }
		}
		if(selectedIds.length!=0 && selectedIds.length==this.state.enquiries.filter(x=>{ return x.status!=3 && x.status!=4 && x.status!=5 }).length){
			selectAll=1;
		}else{
			selectAll=0;
		}
		this.setState({selectedIds,selectAll});
	}
	
	toggleSelectAll() {
        let newSelected = [];
        if (this.state.selectAll === 0) {
            this.state.enquiries.forEach(x => {
				if(x.status!=3 && x.status!=4 && x.status!=5){
					newSelected.push(x.order_id);
				}
            });
        }
		this.setState({
            selectedIds: newSelected,
            selectAll: this.state.selectAll === 0 ? 1 : 0
        });
    }

	editOrder = (e,order_id)  => {        
        swal({
          title: "Are you sure?",
          text: "You want edit or convert enquiry into estimate?",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
		.then((willDelete) => {
			if (willDelete) {
				window.location="/app/enquiries/edit/"+order_id;				
			}else{
				swal("Your operation is canceled!");
			}
		});
	}
	
	cancelOrders = (e,selectedIds)  => {
		if(selectedIds.length==0){
			swal("Warning!","Please select at least one enquiry","warning");
			return;
		}
		
		var msg="Cancel these  enquiries?";
        var success_msg="The enquiries has been canceled.";
        var failure_msg="Failed to cancel enquiries";
		
        swal({
          title: "Are you sure?",
          text: msg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
		.then((willDelete) => {
			if (willDelete) {
				document.getElementById("delete-enquiries").disabled=true;
				var facility_id = localStorage.getItem('facility_id');
				facility_id =  dataCrypto.decrypt(facility_id);
				
				var user_id = localStorage.getItem('user_id');
				var formData = new FormData();
				formData.append('enquiry_ids',JSON.stringify(selectedIds));
				formData.append('user_id',user_id);
				formData.append('facility_id',facility_id);
				
				axios.post(REST_API_END_POINT+'enquiries/cancel-enquiries',formData).then((res)=>{
					var data = res.data;
				
					document.getElementById("delete-enquiries").disabled=false;					
					if(data.status==1){
						// this.dataListRender();
						swal("Success",success_msg,"success");
					}else{
						swal("Failed",failure_msg,"warning");
					}
					// this.props.dataListRender();
				}).catch(e =>{
					console.log("Addition failed , Error ", e);
					document.getElementById("delete-enquiries").disabled=false;
				});
				
			}else{
				swal("Your operation is canceled!");
			}
		});
	}
	
	render(){
		let data = this.state.enquiries;
		if (this.state.search) {
			data = data.filter(row => {
				if(row.vendor_name==null){
					row.vendor_name='';
				}
				return row.order_number.includes(this.state.search) || row.vendor_name.toLowerCase().includes(this.state.search) || row.status_text.includes(this.state.search)
			})
		}
		
		const dataTableColumns = [
			{
				Header: <CustomInput type="checkbox" id="select_all" onChange={this.toggleSelectAll} checked={this.state.selectAll===1} />,
				accessor: "id",
				width:50,
				sortable: false,
				Cell: ( rowInfo )=> {
					if(rowInfo.original.status!=3 && rowInfo.original.status!=4 && rowInfo.original.status!=5&& rowInfo.original.status!=6 && rowInfo.original.status!=7){
						return ( <FormGroup>
							<CustomInput type="checkbox" id={"coupon_"+rowInfo.original.enquiry_id} onChange={event =>this.activeItem(event,rowInfo.original.enquiry_id) } checked={this.state.selectedIds.includes(rowInfo.original.enquiry_id)} />
							</FormGroup> );
					}else{
						return "";
					}
				}
			},
			{
				Header: "Enquiry",
				accessor: "order_number",
				width:100,
				Cell: props => <p className="list-item-heading mb-0">{moment(props.original.timestamp*1000).format('YYYY')}/{zeroPad(props.value,6)}</p>
			},
			{
				Header: customerWord+" Name",
				accessor: "vendor_name",
				Cell: props => <p className="text-muted mb-0">{props.value}</p>
			},
			{
				Header: "Enquiry Date",
				accessor: "timestamp",
				width:120,
				Cell: props => <p className="text-muted mb-0">{moment(props.value*1000).format('DD/MM/YYYY')}</p>
			},
			{
				Header: "Status",
				accessor: "status_badge",
				Cell: props => props.value
			},
			{
				Header: "Options",
				 accessor: "enquiry_id",
				//accessor: "enquiry_id",
				Cell: props => <Fragment>
						<div className="action-btns p-0">
							<ItemDropdown item={<DropdownMenu >
								<DropdownItem className="cursor-pointer" onClick={(e)=>{ this.toggleModalView(e,props.value) }}>
									<span className="d-inline-block">View</span>
								</DropdownItem>
								{props.original.status==1 ? <DropdownItem className="cursor-pointer" onClick={(e)=>{ this.toggleModalEdit(e,props.value) }}  >
								{/* {props.original.status==1 ? <DropdownItem className="cursor-pointer" onClick={(e)=>{ this.editOrder(e,props.value) }}  > */}
									<span className="d-inline-block" >Edit Enquiry</span>
								</DropdownItem>:""}
								{ props.original.status!=3 && props.original.status!=7 &&this.state.user_privileges.indexOf(133)!==-1 ? <DropdownItem className="cursor-pointer" onClick={(e)=>{ this.toggleModalComplete(e,props.value) }} >
									<span className="d-inline-block" >Track Enquiry </span>
								</DropdownItem>:""}
								{props.original.status==3 && this.state.user_privileges.indexOf(133)!==-1 ? <DropdownItem className="cursor-pointer" onClick={(e)=>{ this.toggleModalEximate(e,props.value) }} >
									<span className="d-inline-block" >Convert to Estimate & Quotation</span>
								</DropdownItem>:""}
							</DropdownMenu>} />
						</div>
					</Fragment>
			}
		];
    return (
		<Fragment>
			<Row>
				<Colxx xxs="12">
					<Breadcrumb heading="menu.enquiries" match={this.props.match} />
					<Separator className="mb-5" />
				</Colxx>
			</Row>
			
			<Row>          
				<Colxx md="12">
					<Card>
						<CardBody>	
							<div className="float-sm-right">
								{" "}{this.state.user_privileges.indexOf(133)!==-1 ? <Button
								className=""
									  color="primary"
									  size="sm"
									  onClick={(e)=>{ this.toggleModalAdd() }}
									>
									  Add Enquiry
								</Button>:""}
								{" "}{this.state.user_privileges.indexOf(133)!==-1 ? <Button
									  color="primary"
									  size="sm"
									  id="delete-enquiries"
									  onClick={(e)=>{ this.cancelOrders(e,this.state.selectedIds) }}
									>
									  Cancel Enquiries
								</Button>:""}
							</div>
							<div className="mb-4 dropdown-edit">					
								<FormGroup row>
									<Colxx lg="6">
										<Input
										  type="text"
										  name="table_search"
										  id="table_search"
										  placeholder="Search"
										  value={this.state.search}
										  onChange={e => this.setState({search: e.target.value.toLowerCase()})}
										/>
								  </Colxx>
								</FormGroup>
								<Row>          
									<Colxx lg="12">
										<ReactTable
										  data={data}
										  columns={dataTableColumns}
										  defaultPageSize={10}
										  filterable={false}
										  showPageJump={false}
										  PaginationComponent={DataTablePagination}
										  showPageSizeOptions={true}
										  defaultSorted={[{id: "send_on",desc: false}]}
										/>
									</Colxx>
								</Row>
							</div>
						</CardBody>
					</Card>
				</Colxx>
			</Row>			

			{this.state.modalOpenAdd?<AddEnquiryModal
				modalOpen={this.state.modalOpenAdd}
				toggleModal={this.toggleModalAdd}
				dataListRender={this.dataListRender}
			/>	:""}
			
			<EditEnquiryModal
				modalOpen={this.state.modalOpenEdit}
				toggleModal={this.toggleModalEdit}
				dataListRender={this.dataListRender}
				enquiry_id={this.state.enquiry_id}
			/>	
			
			<ViewModal
				modalOpen={this.state.modalOpenView}
				toggleModal={this.toggleModalView}
				enquiry_id={this.state.enquiry_id}
				dataListRender={this.dataListRender}
			/>	
						
			{this.state.modalOpenComplete?<CompleteModal
				modalOpen={this.state.modalOpenComplete}
				toggleModal={this.toggleModalCompleteData}
				enquiry_id={this.state.enquiry_id}
				dataListRender={this.dataListRender}
			/>:""}
			
		</Fragment>
    );
  }
}
